module.exports = __webpack_public_path__ + "media/images/web/landings/teachers/s4-78da79fbba6e879638e4076099f6627e.jpg";